var React = require('react');

function BusInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"13","y":"5","width":"38","height":"48","rx":"4","key":0}),React.createElement("path",{"d":"M21 18h22a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H21a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1z","key":1}),React.createElement("g",{"transform":"translate(19.294 39.83)","key":2},[React.createElement("circle",{"cx":"3.706","cy":"3.169","r":"3","key":0}),React.createElement("circle",{"cx":"21.706","cy":"3.169","r":"3","key":1})]),React.createElement("path",{"d":"M51 12h5v5m-43-5H8v5m35 36v6m-23-6v6m0-47h24","key":3})]));
}

BusInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = BusInline;

BusInline.default = BusInline;
